/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { useIntl } from 'gatsby-plugin-react-intl';

import Layout from '../Components/Core/Layout';
import SEO from '../Components/Core/Seo';
import SearchResults from '../Components/Screens/SearchResults';
import BackToTop from '../Components/Core/BackToTop';

const SearchResultsPage = ({
  location,
  data: {
    contentfulPageLayout: {
      pageTitle,
      metaDescription,
      languageToggle,
      displayInSiteMap,
      promoCode,
      topNotificationBanner,
      customHeader,
      customFooter,
      internal: { type },
    },
  },
}) => {
  const intl = useIntl();
  return (
    <Layout
      location={location}
      header={customHeader}
      footer={customFooter}
      languageToggle={languageToggle}
      promoCode={promoCode}
      banner={topNotificationBanner}
      contentType={type}
    >
      <SEO
        title={pageTitle}
        description={metaDescription}
        lang={intl.locale}
        location={location}
        noIndex={displayInSiteMap}
      />
      <SearchResults location={location.search} />
      <BackToTop />
    </Layout>
  );
};

SearchResultsPage.propTypes = {
  location: PropTypes.shape().isRequired,
  data: PropTypes.shape().isRequired,
};

export const query = graphql`
  query SearchResults($locale: String = "en-CA") {
    contentfulPageLayout(
      contentful_id: { eq: "3JaCKklcSji5n18Hu7hQdp" }
      node_locale: { eq: $locale }
    ) {
      node_locale
      pageTitle
      metaDescription
      languageToggle
      displayInSiteMap
      promoCode
      internal {
        type
      }
      ...global_header
      ...global_footer
      ...notification_banners
    }
  }
`;

export default SearchResultsPage;

export const Head = ({ location, data, pageContext }) => {
  return (
    <SEO
      data={data.contentfulPageLayout}
      pageContext={pageContext}
      location={location}
    />
  );
};
